export const SHOW_TIME_ROUTE_NAMES = {
  LIST: 'show-time-list',
  EDIT: 'show-time-edit',
}
